<xng-breadcrumb [separator]="separatorTemplate">
  <ng-container *xngBreadcrumbItem="let breadcrumb; let info = info; let first = first">
    @if (info) {
      <mat-icon>{{ info }}</mat-icon>
    }
    @if (!first) {
      <mat-chip-listbox>
        <mat-chip-option disabled>{{ breadcrumb | translate }}</mat-chip-option>
      </mat-chip-listbox>
    }
  </ng-container>
</xng-breadcrumb>
<ng-template #separatorTemplate>
  <mat-icon>arrow_right</mat-icon>
</ng-template>
